import _ from 'lodash'
import {
  FETCH_WAREHOUSES,
  CREATE_WAREHOUSE,
  FETCH_WAREHOUSE,
  EDIT_WAREHOUSE,
  FETCH_WAREHOUSES_FILTERED_BY_PRODUCTS,
  FETCH_WAREHOUSE_STOCK,
  EDIT_WAREHOUSE_STOCKS
} from '../actions/types'

const INITIAL_STATE = {
  warehouses: {},
  filtered_by_products: [],
  selectedStock: null
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_WAREHOUSES:
      return {
        ...state,
        warehouses: _.mapKeys(action.payload, 'id')
      }
    case CREATE_WAREHOUSE:
    case FETCH_WAREHOUSE:
    case EDIT_WAREHOUSE:
      if (action.payload && action.payload.id) {
        return {
          ...state,
          warehouses: {
            ...state.warehouses,
            [action.payload.id]: action.payload
          }
        }
      }
      return state
    case FETCH_WAREHOUSES_FILTERED_BY_PRODUCTS:
      return {
        ...state,
        filtered_by_products: action.payload
      }
    case FETCH_WAREHOUSE_STOCK:
    case EDIT_WAREHOUSE_STOCKS:
      return {
        ...state,
        selectedStock: action.payload
      }
    case 'CLEAR_WAREHOUSES':
      return INITIAL_STATE
    default:
      return state
  }
}
